document.addEventListener("sections:loaded", () => {
  const gallery = document.querySelector(".product-gallery-main");

  if (!gallery) {
    return;
  }

  const images = Array.from(gallery.querySelectorAll("img"));
  const trigger = gallery.querySelector(".product-zoom-trigger");
  const thumbButtons = Array.from(document.querySelectorAll(".product-gallery-thumbs button"));

  let activeIndex = images.findIndex((img) => img.classList.contains("is-active"));
  if (activeIndex === -1) {
    activeIndex = 0;
  }

  const setActiveImage = (index) => {
    activeIndex = (index + images.length) % images.length;
    images.forEach((img, i) => img.classList.toggle("is-active", i === activeIndex));
    thumbButtons.forEach((button, i) => button.classList.toggle("is-active", i === activeIndex));
  };

  thumbButtons.forEach((button, index) => {
    button.addEventListener("click", () => setActiveImage(index));
  });

  const modal = document.getElementById("product-zoom");

  if (!modal) {
    return;
  }

  const closeButton = modal.querySelector(".product-zoom-close");
  const prevButton = modal.querySelector(".product-zoom-prev");
  const nextButton = modal.querySelector(".product-zoom-next");
  const viewport = modal.querySelector(".product-zoom-viewport");
  const zoomImage = modal.querySelector(".product-zoom-image");
  const isTouchDevice = window.matchMedia("(hover: none), (pointer: coarse)").matches;

  let zoomIndex = 0;

  const resetImageZoom = () => {
    zoomImage.classList.remove("is-zoomed");
    zoomImage.style.transform = "";
    zoomImage.style.transformOrigin = "";
  };

  const showZoomImage = (index) => {
    zoomIndex = (index + images.length) % images.length;
    const nextImage = images[zoomIndex];
    zoomImage.removeAttribute("srcset");
    zoomImage.removeAttribute("sizes");
    zoomImage.src = nextImage.src;
    zoomImage.alt = nextImage.alt;
    resetImageZoom();
  };

  const openModal = (index) => {
    showZoomImage(index);
    modal.classList.add("is-open");
    document.body.classList.add("no-scroll");
  };

  const closeModal = () => {
    modal.classList.remove("is-open");
    document.body.classList.remove("no-scroll");
    resetImageZoom();
  };

  if (trigger) {
    trigger.addEventListener("click", () => openModal(activeIndex));
  }

  images.forEach((img, index) => {
    img.style.cursor = "zoom-in";
    img.addEventListener("click", () => openModal(index));
  });

  closeButton.addEventListener("click", closeModal);
  prevButton?.addEventListener("click", () => showZoomImage(zoomIndex - 1));
  nextButton?.addEventListener("click", () => showZoomImage(zoomIndex + 1));

  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (!modal.classList.contains("is-open")) {
      return;
    }
    if (event.key === "Escape") {
      closeModal();
    } else if (event.key === "ArrowLeft") {
      showZoomImage(zoomIndex - 1);
    } else if (event.key === "ArrowRight") {
      showZoomImage(zoomIndex + 1);
    }
  });

  if (isTouchDevice) {
    zoomImage.addEventListener("click", (event) => {
      const isZoomed = zoomImage.classList.toggle("is-zoomed");
      if (isZoomed) {
        const rect = zoomImage.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        zoomImage.style.transformOrigin = `${x}% ${y}%`;
        zoomImage.style.transform = "scale(2.2)";
      } else {
        zoomImage.style.transform = "";
      }
    });
  } else {
    viewport.addEventListener("mousemove", (event) => {
      const rect = viewport.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      zoomImage.classList.add("is-zoomed");
      zoomImage.style.transformOrigin = `${x}% ${y}%`;
      zoomImage.style.transform = "scale(2.2)";
    });

    viewport.addEventListener("mouseleave", resetImageZoom);
  }
});
